var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect2, _path23, _path24, _rect3, _path25, _line, _line2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect4, _path34, _path35, _path36, _rect5, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 200,
    viewBox: "0 0 241 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.72 34.667H73.2801C65.4854 34.667 59.1665 41.2331 59.1665 49.3327V49.3346C59.1665 57.4343 65.4854 64.0003 73.2801 64.0003H111.72C119.514 64.0003 125.833 57.4343 125.833 49.3346V49.3327C125.833 41.2331 119.514 34.667 111.72 34.667Z",
    fill: "#E6EFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.844 86.667H158.489C152.236 86.667 147.167 93.2331 147.167 101.333V101.335C147.167 109.434 152.236 116 158.489 116H203.844C210.097 116 215.167 109.434 215.167 101.335V101.333C215.167 93.2331 210.097 86.667 203.844 86.667Z",
    fill: "#E6EFF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.131 149.333H70.5357C63.5205 149.333 57.8335 155.302 57.8335 162.665V162.667C57.8335 170.031 63.5205 176 70.5357 176H105.131C112.147 176 117.833 170.031 117.833 162.667V162.665C117.833 155.302 112.147 149.333 105.131 149.333Z",
    fill: "#E6EFF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.464 16H151.869C144.853 16 139.167 21.9691 139.167 29.3325V29.3342C139.167 36.6975 144.853 42.6667 151.869 42.6667H186.464C193.48 42.6667 199.167 36.6975 199.167 29.3342V29.3325C199.167 21.9691 193.48 16 186.464 16Z",
    fill: "#E6EFF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7626 92L19.9037 92C12.8691 92 7.1665 97.6707 7.1665 104.666V104.668C7.1665 111.663 12.8691 117.333 19.9037 117.333L63.7626 117.333C70.7972 117.333 76.4998 111.663 76.4998 104.668V104.666C76.4998 97.6707 70.7972 92 63.7626 92Z",
    fill: "#E6EFF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.154 124.628H113.675V153.775H145.154V124.628Z",
    fill: "#F0C1D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5639 58.8375C79.5505 58.9549 79.5303 59.0722 79.5102 59.1895C78.7978 63.7239 75.4577 67.858 72.3192 70.9362C68.0651 75.0979 63.522 78.9076 59.1066 82.8761C57.9439 83.9251 56.6805 83.863 55.4641 82.8209C54.2409 81.7787 53.0379 80.709 51.8417 79.6323C47.3591 75.5948 42.6144 71.8334 38.8509 67.0229C35.7056 63.0062 34.1666 58.4994 35.2419 53.3369C36.3374 48.064 39.328 44.3647 44.5163 43.0672C49.3349 41.8594 53.4613 43.4123 56.6133 47.3601C57.3592 48.2918 57.581 47.8501 58.0851 47.2427C61.1362 43.5365 65.0543 41.9975 69.6646 42.9637C76.7279 44.4475 80.5115 51.784 79.5639 58.8513V58.8375Z",
    fill: "#ECA2C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.26 156.107H108.266C107.601 156.107 107.062 155.282 107.062 154.27C107.062 153.257 107.601 152.433 108.266 152.433H150.26C150.925 152.433 151.464 153.257 151.464 154.27C151.464 155.282 150.925 156.107 150.26 156.107Z",
    fill: "#E580B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.154 129.897L113.675 129.292V144.449L145.154 137.173V129.897Z",
    fill: "#002E52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.343 56.9029C185.021 55.5263 183.244 54.6748 181.286 54.6748H76.9762C72.9891 54.6748 69.7534 58.2464 69.7534 62.6553V128.103C149.124 129.38 177.891 77.9965 186.343 56.9029Z",
    fill: "#F0C1D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.358 57.0068C177.905 78.004 149.134 129.136 69.7534 127.87V132.441C69.7534 134.565 71.3184 136.288 73.2503 136.288H184.263C186.698 136.288 188.675 134.117 188.675 131.434V62.9011C188.675 60.5754 187.782 58.4851 186.358 57.0068Z",
    fill: "#F0C1D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.89 60.7295H76.4282V128.126H181.89V60.7295Z",
    fill: "#FFDBED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.1665,
    y: 96.7256,
    width: 29.3333,
    height: 92,
    rx: 2.66667,
    transform: "rotate(-90 83.1665 96.7256)",
    fill: "#002E52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42 74.6428H119.102V77.7907H111.034V81.7315H118.636V84.8794H111.034V88.8667H119.102V92.0146H107.42V74.6428ZM121.151 74.6428H124.765V82.1512H131.527V74.6428H135.142V92.0146H131.527V85.2991H124.765V92.0146H121.151V74.6428ZM138.229 74.6428H144.875C146.725 74.6428 148.21 75.1247 149.329 76.0885C150.464 77.0523 151.031 78.4203 151.031 80.1925C151.031 81.3584 150.767 82.3611 150.238 83.2005C149.71 84.0244 148.971 84.654 148.023 85.0892L151.987 92.0146H147.93L144.409 85.7188H141.844V92.0146H138.229V74.6428ZM144.898 82.5709C145.66 82.5709 146.266 82.3533 146.717 81.918C147.184 81.4827 147.417 80.9076 147.417 80.1925C147.417 79.4774 147.184 78.9022 146.717 78.467C146.266 78.0162 145.66 77.7907 144.898 77.7907H141.844V82.5709H144.898Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.5 102.059C104.5 101.323 105.097 100.726 105.833 100.726H165.833C166.57 100.726 167.167 101.323 167.167 102.059V128.726H104.5V102.059Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.833 112.726H119.167",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.167 112.726H149.833",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.833 108.726H119.167",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.167 108.726H149.833",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.833 116.726H129.833",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.167 116.726H157.833",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.833 120.726H129.833",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.167 120.726H157.833",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 178.5,
    y: 114.725,
    width: 40,
    height: 28,
    stroke: "#002E52",
    strokeWidth: 1.33333
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 62.4555H34.3353L36.8362 50.667L39.337 71.5235L42.6715 55.201L45.1723 65.1759L49.3404 51.5738L51.8413 72.4303L56.0093 54.2942L57.6766 61.5487H64.3455",
    stroke: "#00457A",
    strokeWidth: 1.44997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.403 89.2592L174.425 89.0272C172.216 89.0165 170.421 90.7987 170.417 93.0078L170.281 160.611C170.276 162.82 172.063 164.619 174.272 164.63L222.251 164.862C224.46 164.873 226.255 163.091 226.259 160.881L226.395 93.2786C226.4 91.0694 224.613 89.2699 222.403 89.2592Z",
    fill: "#BFD6E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 178.499,
    y: 121.392,
    width: 40,
    height: 25.3333,
    rx: 2,
    fill: "#BFD6E8",
    stroke: "#002E52",
    strokeWidth: 1.33333
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M216.499 127.392C217.972 127.392 219.166 126.198 219.166 124.726C219.166 123.253 217.972 122.059 216.499 122.059L216.499 127.392ZM179.166 127.392L216.499 127.392L216.499 122.059L179.166 122.059L179.166 127.392Z",
    fill: "#002E52"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 177.833,
    y1: 133.392,
    x2: 217.833,
    y2: 133.392,
    stroke: "#002E52",
    strokeWidth: 1.33333
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 177.833,
    y1: 140.059,
    x2: 217.833,
    y2: 140.059,
    stroke: "#002E52",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11275_120072)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M179.31 111.687L191.08 111.687C192.215 111.687 192.925 110.457 192.355 109.475L186.97 100.149L186.97 95.6481C187.362 95.5608 187.648 95.1904 187.596 94.7606C187.547 94.3482 187.162 94.0547 186.747 94.0547L183.647 94.0547C183.231 94.0547 182.847 94.3482 182.798 94.7606C182.745 95.1904 183.032 95.5608 183.423 95.6481L183.423 100.145L178.032 109.475C177.465 110.457 178.175 111.687 179.307 111.687L179.31 111.687Z",
    fill: "#FCFDFD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M186.594 101.601L183.796 101.601L179.194 109.575C178.905 110.077 179.265 110.705 179.847 110.705L190.547 110.705C191.129 110.705 191.49 110.077 191.201 109.575L186.598 101.601L186.594 101.601Z",
    fill: "#D65193"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.34
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M190.133 107.735C186.761 109.557 183.134 110.344 179.11 109.888C179.105 109.888 179.101 109.888 179.093 109.888C179.055 110.307 179.373 110.705 179.838 110.705L190.539 110.705C191.121 110.705 191.481 110.076 191.192 109.574L190.128 107.735L190.133 107.735Z",
    fill: "#D65193"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184.776 100.992C185.005 100.992 185.192 100.806 185.192 100.576C185.192 100.346 185.005 100.16 184.776 100.16C184.546 100.16 184.36 100.346 184.36 100.576C184.36 100.806 184.546 100.992 184.776 100.992Z",
    fill: "#E580B2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M186.03 98.5344C186.03 98.8489 185.775 99.104 185.461 99.104C185.146 99.104 184.891 98.8489 184.891 98.5344C184.891 98.2199 185.146 97.9648 185.461 97.9648C185.775 97.9648 186.03 98.2199 186.03 98.5344Z",
    fill: "#E580B2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M183.637 108.441C184.067 108.441 184.416 108.092 184.416 107.662C184.416 107.232 184.067 106.883 183.637 106.883C183.206 106.883 182.857 107.232 182.857 107.662C182.857 108.092 183.206 108.441 183.637 108.441Z",
    fill: "#E580B2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.975 105.135C184.975 105.46 184.713 105.722 184.388 105.722C184.063 105.722 183.801 105.46 183.801 105.135C183.801 104.81 184.063 104.548 184.388 104.548C184.713 104.548 184.975 104.81 184.975 105.135Z",
    fill: "#E580B2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M187.603 106.963C187.603 107.288 187.341 107.55 187.016 107.55C186.691 107.55 186.429 107.288 186.429 106.963C186.429 106.638 186.691 106.376 187.016 106.376C187.341 106.376 187.603 106.638 187.603 106.963Z",
    fill: "#E580B2"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99.166,
    y: 120.726,
    width: 16,
    height: 20,
    rx: 1.33333,
    transform: "rotate(180 99.166 120.726)",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6839 112.093C87.3884 112.093 84.7168 114.035 84.7168 116.432L84.7168 117.516C84.7168 117.951 85.1948 118.288 85.7845 118.36L87.4267 118.562C90.0767 118.887 92.7829 118.887 95.4329 118.562L97.0751 118.36C97.6648 118.288 98.1428 117.951 98.1428 117.516L98.1428 116.432C98.1428 114.035 95.4712 112.093 92.1757 112.093L90.6839 112.093Z",
    fill: "#E580B2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6645 112.152C93.6066 113.32 92.6661 114.33 91.4297 114.33C90.2364 114.33 89.3188 113.389 89.2041 112.274C89.7843 112.156 90.4003 112.093 91.0387 112.093L92.6024 112.093C92.9644 112.093 93.3193 112.113 93.6645 112.152Z",
    fill: "#F0C1D9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5826 108.024C94.5835 107.991 94.584 107.957 94.584 107.924C94.584 106.107 93.1458 104.635 91.3716 104.635C89.5974 104.635 88.1592 106.107 88.1592 107.924C88.1592 107.957 88.1597 107.991 88.1607 108.024C87.8824 108.204 87.7002 108.503 87.7002 108.841C87.7002 109.262 87.9811 109.621 88.3781 109.767C88.6704 111.117 89.8996 112.131 91.3716 112.131C92.8437 112.131 94.0729 111.117 94.3652 109.767C94.7621 109.621 95.043 109.262 95.043 108.841C95.043 108.503 94.8608 108.204 94.5826 108.024Z",
    fill: "#F0C1D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89.938,
    y: 111.348,
    width: 2.98355,
    height: 1.49177,
    fill: "#F0C1D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 110.059L217.833 110.059",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 106.059L217.833 106.059",
    stroke: "#002E52",
    strokeWidth: 1.20268,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M212.331 101.983C211.613 101.413 211.149 100.524 211.152 99.5423L211.158 95.0043C211.162 94.6978 211.409 94.4578 211.707 94.4554C212.014 94.4598 212.254 94.7073 212.258 95.0052L212.252 99.5432C212.247 100.651 213.144 101.546 214.252 101.554L214.59 101.555C215.462 101.558 216.165 100.85 216.175 99.9854L216.196 88.4983C216.201 88.066 216.028 87.6616 215.725 87.3506C215.422 87.0396 215.018 86.8735 214.579 86.8762L214.013 86.8775C213.071 86.8745 212.296 87.6376 212.288 88.5882L212.29 88.8707C212.286 89.1772 212.039 89.4172 211.741 89.4196C211.434 89.4151 211.194 89.1677 211.19 88.8698L211.189 88.5873C211.196 87.0322 212.464 85.7737 214.011 85.7788L214.576 85.7775C215.307 85.7809 215.977 86.0739 216.5 86.5876C217.016 87.11 217.292 87.7931 217.298 88.5146L217.276 100.002C217.275 101.478 216.071 102.674 214.594 102.669L214.256 102.668C213.526 102.664 212.868 102.409 212.34 101.99L212.331 101.983Z",
    fill: "#002E52"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 108V149.761C23.9922 151.234 25.1861 152.428 26.6589 152.428H57.182C58.6547 152.428 59.8486 151.234 59.8486 149.761L59.8486 116.497C59.8486 115.847 59.6113 115.219 59.1812 114.732L51.6807 106.235C51.1745 105.661 50.4464 105.333 49.6815 105.333H26.6589C25.1861 105.333 23.9922 106.527 23.9922 108Z",
    fill: "white",
    stroke: "#BFD6E8",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 123.737C16.5 121.258 18.51 119.248 20.9895 119.248H28.8998C30.2595 119.248 31.546 119.864 32.3982 120.924L34.688 123.771H62.9369C65.4163 123.771 67.4263 125.781 67.4263 128.261V150.943C67.4263 153.423 65.4163 155.433 62.9369 155.433H20.9895C18.51 155.433 16.5 153.423 16.5 150.943V123.737Z",
    fill: "#F0C1D9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9914 132.775C40.918 132.775 40.0479 133.646 40.0479 134.719V138.606H36.1047C35.0313 138.606 34.1611 139.476 34.1611 140.549C34.1611 141.623 35.0313 142.493 36.1047 142.493H40.0479V146.381C40.0479 147.454 40.918 148.324 41.9914 148.324C43.0649 148.324 43.935 147.454 43.935 146.381V142.493H47.7663C48.8397 142.493 49.7099 141.623 49.7099 140.549C49.7099 139.476 48.8397 138.606 47.7663 138.606H43.935V134.719C43.935 133.646 43.0649 132.775 41.9914 132.775Z",
    fill: "#E580B2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11275_120072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7219,
    height: 17.6292,
    fill: "white",
    transform: "translate(177.833 94.0586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhr);
export default __webpack_public_path__ + "static/media/EHR.22da7e33f4d9b64b90f91edcbb1cd05b.svg";
export { ForwardRef as ReactComponent };